<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { dialogProps } from './dialog'

defineOptions({
  name: 'VsDialog',
})

const props = defineProps(dialogProps)

// init here
</script>
